import _ from 'lodash';
import { getAllAccounts } from '../multiLoanDashboard/accountsSelector';
import { getDrawdownAmount as getOfferConfigurationDrawDownAmount } from './offerConfigurationSelectors';
import { getDrawdownAmountFromQueryParams } from './DrawDownHelper';
import { RootState } from '@iwProvider/configureStore';

export const getDrawDownAmount = (state: RootState) => {
    const amountFromParams = getDrawdownAmountFromQueryParams();
    if (amountFromParams) {
        return parseInt(amountFromParams);
    }

    return (
        getOfferConfigurationDrawDownAmount(state) ||
        state?.api?.customer_state?.data?.ui?.draw_down?.amount
    );
};

export const getOutstandingBalanceOnCurrentDay = (state: RootState) => {
    const latestOngoingLoan = _.find(getAllAccounts(state), {
        loan_status: 'ongoing'
    });

    return latestOngoingLoan?.balance?.total ?? 0;
};
